// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import { FunctionsClient } from '@supabase/functions-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

async function extractEdgeFunctionError(res: Response): Promise<string | null> {
  try {
    const ct = res.headers.get('Content-Type') || '';
    if (!ct.includes('application/json')) return null;
    const body = await res.clone().json();
    if (typeof body?.error === 'string' && body.error.trim()) return body.error.trim();
    if (typeof body?.message === 'string' && body.message.trim()) return body.message.trim();
  } catch { /* ignore */ }
  return null;
}

// Patch FunctionsClient.prototype.invoke so ALL callers get the real error message
// from Edge Functions that return 4xx/5xx with { error: "..." } body.
// Uses .clone() to preserve the original Response for downstream consumers.
const _origInvoke = FunctionsClient.prototype.invoke;
FunctionsClient.prototype.invoke = async function (functionName: string, options?: object) {
  const result = await _origInvoke.call(this, functionName, options as never);
  if (!result.error) return result;

  const errMsg = (result.error as { message?: string }).message ?? '';
  const isGeneric = errMsg === 'Edge Function returned a non-2xx status code'
    || errMsg === 'Relay Error invoking the Edge Function';
  if (!isGeneric) return result;

  const res: Response | undefined =
    (result as { response?: Response }).response
    ?? (result.error as { context?: Response }).context;

  if (!res || typeof res.clone !== 'function') return result;

  const realMessage = await extractEdgeFunctionError(res);
  if (!realMessage) return result;

  const patchedError = Object.assign(new Error(realMessage), {
    name: (result.error as Error).name,
    context: (result.error as { context?: unknown }).context,
  });
  return { ...result, error: patchedError };
};